/**
 * 배송비 노출정책에 맞게 데이터를 만드는 함수
 * ui/topInfo/DeliveryInfo/DeliveryFee.jsx에서 쓰인다.
 */
export function getRefinedDeliveryFee(htDealInfo) {
  if (!htDealInfo) {
    return null;
  }

  const DELIVERY_COUPON_PRICE = 2500; // 배송비 지원 쿠폰 가격
  const DELIVERY_FREE_CONDITION = 10000; // 배송비 무료 조건 가격

  const {
    isEventDeliveryFree, // 무료배송데이 여부
  } = htDealInfo;

  const {
    deliveryFeePolicy, // FREE(무료배송), PER(선결제), CONDITION(조건부 무료배송), AFTER(착불), NONE(NONE)
    deliveryFee, // 배송비
    minTotalPaidForFreeDelivery, // 무료배송 최소금액
  } = htDealInfo.deliveryInfo;

  const refinedDeliveryFee = {
    deliveryFeeText: "", // 배송비(앞 텍스트)
    isFeeTextGreen: false, // 배송비(앞 텍스트)의 색상이 초록색인지
    deliveryCondition: "", // 배송비 조건(뒤 텍스트)
  };

  const deliveryFeeWithComma = TMON.util.numberWithComma(deliveryFee);
  const minTotalPaidForFreeDeliveryWithComma = TMON.util.numberWithComma(
    minTotalPaidForFreeDelivery
  );

  // 무료배송데이 X
  if (!isEventDeliveryFree) {
    switch (deliveryFeePolicy) {
      // 무료배송
      case "FREE":
        refinedDeliveryFee.isFeeTextGreen = true;
        refinedDeliveryFee.deliveryFeeText = "무료배송";
        break;
      // 선불
      case "PER":
        if (deliveryFee > 0) {
          refinedDeliveryFee.isFeeTextGreen = false;
          refinedDeliveryFee.deliveryFeeText = `배송비 선불 ${deliveryFeeWithComma}원`;
        } else {
          refinedDeliveryFee.isFeeTextGreen = false;
          refinedDeliveryFee.deliveryFeeText = "배송비 선불 (컨텐츠 참고)";
        }
        break;
      // 착불
      case "AFTER":
        if (deliveryFee > 0) {
          refinedDeliveryFee.isFeeTextGreen = false;
          refinedDeliveryFee.deliveryFeeText = `배송비 착불 ${deliveryFeeWithComma}원`;
        } else {
          refinedDeliveryFee.isFeeTextGreen = false;
          refinedDeliveryFee.deliveryFeeText = "배송비 착불 (컨텐츠 참고)";
        }
        break;
      // 조건부 무료배송
      case "CONDITION":
        if (deliveryFee > 0) {
          refinedDeliveryFee.isFeeTextGreen = false;
          refinedDeliveryFee.deliveryFeeText = `${deliveryFeeWithComma}원`;
          refinedDeliveryFee.deliveryCondition = `${minTotalPaidForFreeDeliveryWithComma}원 이상 구매시 무료배송`;
        } else {
          refinedDeliveryFee.isFeeTextGreen = false;
          refinedDeliveryFee.deliveryFeeText = "조건부무료배송 (컨텐츠 참고)";
        }
        break;
      default:
        break;
    }
    // 무료배송데이 O
  } else {
    switch (deliveryFeePolicy) {
      // 무료배송
      case "FREE":
        refinedDeliveryFee.isFeeTextGreen = true;
        refinedDeliveryFee.deliveryFeeText = "무료배송";
        refinedDeliveryFee.deliveryCondition = "무제한";
        break;
      // 선불
      case "PER":
        if (deliveryFee <= 2500) {
          refinedDeliveryFee.isFeeTextGreen = true;
          refinedDeliveryFee.deliveryFeeText = "무료배송";
          refinedDeliveryFee.deliveryCondition = `${TMON.util.numberWithComma(
            DELIVERY_FREE_CONDITION
          )}원 이상 구매 시 1회`;
        }
        if (deliveryFee > 2500) {
          refinedDeliveryFee.isFeeTextGreen = true;
          refinedDeliveryFee.deliveryFeeText = `${TMON.util.numberWithComma(
            deliveryFee - DELIVERY_COUPON_PRICE
          )}원 (배송비지원쿠폰 적용시)`;
          refinedDeliveryFee.deliveryCondition = `${TMON.util.numberWithComma(
            DELIVERY_FREE_CONDITION
          )}원 이상 구매 시 1회`;
        }
        break;
      // 착불
      case "AFTER":
        break;
      // 조건부 무료배송
      case "CONDITION":
        if (deliveryFee <= 2500) {
          refinedDeliveryFee.isFeeTextGreen = true;
          refinedDeliveryFee.deliveryFeeText = "무료배송";
          refinedDeliveryFee.deliveryCondition = `${TMON.util.numberWithComma(
            DELIVERY_FREE_CONDITION
          )}원 이상 구매 시 1회`;
        }
        if (deliveryFee > 2500) {
          refinedDeliveryFee.isFeeTextGreen = true;
          refinedDeliveryFee.deliveryFeeText = `${TMON.util.numberWithComma(
            deliveryFee - DELIVERY_COUPON_PRICE
          )}원 (배송비지원쿠폰 적용시)`;
          refinedDeliveryFee.deliveryCondition = `${TMON.util.numberWithComma(
            DELIVERY_FREE_CONDITION
          )}원 이상 구매 시 1회`;
        }
        break;
      default:
        break;
    }
  }

  return refinedDeliveryFee;
}

/**
 * 도착예정일(평균배송일) 노출정책에 맞게 데이터를 만드는 함수
 * ui/topInfo/DeliveryInfo/DeliveryEstimatedDate.jsx에서 쓰인다.
 */
export function getRefinedDeliveryEstimatedDate(htDealInfo) {
  if (!htDealInfo) {
    return null;
  }

  const {
    deliveryType, // DD(당일발송), ND(익일발송), ED(예외발송), CD(종료후발송), NONE(NONE)
    deliveryProductType, // DP01(냉장/냉동/신선 식품), DP02(해외직배송), DP03(해외구매대행), DP04(화물/설치), DP05(주문제작), DP06(주문 후 발주), DP07(일반상품), DP08(예외상품), NONE(NONE)
    expectedDeliveryEndDate, // 도착 예정일
    averageDeliveryDays, // 평균 배송일
    deliveryPackage, // DELIVERY, POST(우편배송 여부의 판단을 위해 사용), FREIGHT, NONE
    postCriticalType, // 우편 배송시 임계치 단위(C: 개수, A: 가격)
    postCriticalValue, // 우편 배송시 임계치 값
  } = htDealInfo.deliveryInfo;

  const refinedDeliveryEstimatedDate = {
    expectedDeliveryEndDate: "", // 도착 예정일(MM/DD(요일))
    averageDeliveryDays: "", // 평균 배송일(n.n일)
    fixedText: "", // 고정 문구
    isLotteDeal: false, // 롯데백화점, 롯데아울렛 딜인지(이 경우 문구 내 '5'에 색상이 들어감. 하드코딩된 문구는 jsx에 있다.)
    isPostDeal: deliveryPackage === "POST", // 우편 딜인지 여부
    postConditionText: "", // 우편배송 조건(n개(원) 이하 우편배송/n개(원) 초과 택배배송)
    toolTipText: "", // 툴팁에 들어갈 텍스트
    case: "", // 배송유형 노출 케이스(주로 팝업에서 쓰이지만, 도착예정일을 노출할지 말지 조건으로도 쓰인다.)
  };

  const typedExpectedDeliveryEndDate = TMON.oApp.oUtil.getDayType1(
    expectedDeliveryEndDate
  );
  const { verticalType } = TMON.htStaticData.htDealInfo.categoryInfo;

  // 롯데백화점, 롯데아울렛
  if (verticalType === "LOTTE_DEPARTMENT" || verticalType === "OUTLET") {
    refinedDeliveryEstimatedDate.fixedText = "배송일 평균 5일 정도 소요 예정"; // 실제로 하드코딩돼 쓰이는 문구는 jsx에 있다.
    refinedDeliveryEstimatedDate.isLotteDeal = true;
    refinedDeliveryEstimatedDate.case = 8;
    return refinedDeliveryEstimatedDate;
  }

  switch (deliveryType) {
    // 당일발송
    case "DD":
      switch (deliveryProductType) {
        // 일반상품
        case "DP07":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 1;
          break;
        // 냉장/냉동/신선식품
        case "DP01":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 2;
          break;
        // 조건에는 없지만 딜이 있을 경우를 대비한 방어코드
        default:
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 1;
          break;
      }
      break;
    // 익일발송
    case "ND":
      switch (deliveryProductType) {
        // 일반상품
        case "DP07":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 1;
          break;
        // 냉장/냉동/신선식품
        case "DP01":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 2;
          break;
        // 조건에는 없지만 딜이 있을 경우를 대비한 방어코드
        default:
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 1;
          break;
      }
      break;
    // 예외발송
    case "ED":
      switch (deliveryProductType) {
        // 일반상품
        case "DP07":
          return refinedDeliveryEstimatedDate;
        // 화물/설치
        case "DP04":
          refinedDeliveryEstimatedDate.fixedText = "상품설명 내 배송일정 안내";
          refinedDeliveryEstimatedDate.case = 3;
          break;
        // 주문제작
        case "DP05":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 1;
          break;
        // 주문 후 발주
        case "DP06":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 1;
          break;
        // 해외직배송
        case "DP02":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 4;
          break;
        // 해외구매대행
        case "DP03":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.averageDeliveryDays = averageDeliveryDays;
          refinedDeliveryEstimatedDate.case = 4;
          break;
        // 예외상품
        case "DP08":
          return refinedDeliveryEstimatedDate;
        default:
          break;
      }
      break;
    // 종료 후 발송
    case "CD":
      switch (deliveryProductType) {
        // 일반상품
        case "DP07":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.case = 5;
          break;
        // 냉장/냉동/신선식품
        case "DP01":
          refinedDeliveryEstimatedDate.fixedText = "판매종료 후 순차 발송";
          refinedDeliveryEstimatedDate.case = 6;
          break;
        // 화물/설치
        case "DP04":
          refinedDeliveryEstimatedDate.fixedText = "상품설명 내 배송일정 안내";
          refinedDeliveryEstimatedDate.case = 3;
          break;
        // 주문제작
        case "DP05":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.case = 5;
          break;
        // 주문 후 발주
        case "DP06":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.case = 5;
          break;
        // 해외직배송
        case "DP02":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.case = 7;
          break;
        // 해외구매대행
        case "DP03":
          refinedDeliveryEstimatedDate.expectedDeliveryEndDate = typedExpectedDeliveryEndDate;
          refinedDeliveryEstimatedDate.case = 7;
          break;
        default:
          break;
      }
      break;
    default:
      break;
  }

  if (expectedDeliveryEndDate && averageDeliveryDays) {
    refinedDeliveryEstimatedDate.toolTipText =
      "도착 예정일은 판매자가 설정한 예정일, 평균 배송일은 최근 7일간 평균 배송 소요일입니다.";
  } else if (expectedDeliveryEndDate && !averageDeliveryDays) {
    refinedDeliveryEstimatedDate.toolTipText =
      "판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있습니다.";
  } else if (!expectedDeliveryEndDate && averageDeliveryDays) {
    refinedDeliveryEstimatedDate.toolTipText =
      "최근 7일간 평균 배송 소요일 입니다.";
  }

  if (deliveryPackage === "POST") {
    const pType = postCriticalType === "A" ? "원" : "개";
    const postCriticalValueWithComma =
      typeof postCriticalValue === "number"
        ? TMON.util.numberWithComma(postCriticalValue)
        : postCriticalValue;
    refinedDeliveryEstimatedDate.postConditionText = `${postCriticalValueWithComma}${pType} 이하 우편배송 / ${postCriticalValueWithComma}${pType} 초과 택배배송`;
  }

  return refinedDeliveryEstimatedDate;
}

/**
 * 해외 직배송/해외 구매대행 노출정책에 맞게 데이터를 만드는 함수
 * ui/topInfo/DeliveryInfo/DeliveryOversea.jsx에서 쓰인다.
 */
export function getRefinedDeliveryOversea(htDealInfo) {
  if (!htDealInfo) {
    return null;
  }

  const {
    deliveryProductType, // DP01(냉장/냉동/신선 식품), DP02(해외직배송), DP03(해외구매대행), DP04(화물/설치), DP05(주문제작), DP06(주문 후 발주), DP07(일반상품), DP08(예외상품), NONE(NONE)
  } = htDealInfo.deliveryInfo;

  const refinedDeliveryOversea = {
    fixedText: "",
  };

  switch (deliveryProductType) {
    case "DP02":
      refinedDeliveryOversea.fixedText = "해외 직배송";
      break;
    case "DP03":
      refinedDeliveryOversea.fixedText = "해외 구매대행";
      break;
    default:
      break;
  }

  return refinedDeliveryOversea;
}

/**
 * 책임배송보상, 품절보상, 편의점 픽업배송 노출 정책에 맞게 데이터를 만드는 함수
 * ui/topInfo/DeliveryInfo/DeliveryEtc.jsx에서 쓰인다.
 */
export function getRefinedDeliveryEtc(htDealInfo) {
  if (!htDealInfo) {
    return null;
  }

  const {
    isCvsPickupSupported, // 편의점 픽업배송 여부
  } = htDealInfo;

  const {
    dutyDeliveryRefund, // 책임배송보상 여부
    soldOutReward, // 품절보상제 여부
    deliveryCorp, // 택배사
  } = htDealInfo.deliveryInfo;

  const refinedDeliveryEtc = {
    deliveryCorp,
    dutyDeliveryText: "",
    soldOutText: "",
    cvsPickupText: "",
  };

  if (dutyDeliveryRefund) {
    refinedDeliveryEtc.dutyDeliveryText = "책임배송보상";
  }
  if (soldOutReward) {
    refinedDeliveryEtc.soldOutText = "품절 보상";
  }
  if (isCvsPickupSupported) {
    refinedDeliveryEtc.cvsPickupText = "편의점 픽업 배송";
  }

  return refinedDeliveryEtc;
}

/**
 * 팝업 레이어에 보낼 데이터
 * 팝업에서만 쓰이는 데이터의 분기는 팝업에 있다.
 */
export function getDeliveryLayerOptions(htStaticData) {
  const { hideDeliveryBannerInfo } = htStaticData.htDealInfo.contentInfo;
  const { verticalType } = htStaticData.htDealInfo.categoryInfo;
  const { refundType } = htStaticData.htDealInfo.refundInfo;

  const {
    isNotGuaranteeDeal,
    isPurchaseAvailable,
    htDealInfo,
    htDealInfo: { deliveryInfo, isEventDeliveryFree, isCvsPickupSupported },
  } = htStaticData;

  const {
    deliveryFee,
    deliveryFeePolicy,
    isExtraChargePrepayment,
    hasLongDistanceDelivery,
    longDistanceExtraDeliveryFee,
    extraChargeJeju,
    extraChargeExternalJeju,
    extraChargeDiscriminationMin,
    extraChargeDiscriminationMax,
    deliveryCorp,
    hasDifferentDeliveryFeePerLocal,
    dutyDeliveryRefund,
    soldOutReward,
    deliveryFeeContentPerLocal,
    deliveryType,
    deliveryProductType,
    deliverySpotType,
    minTotalPaidForFreeDelivery,
  } = deliveryInfo;

  return {
    refinedData: {
      deliveryFee: getRefinedDeliveryFee(htDealInfo),
      deliveryEstimatedDate: getRefinedDeliveryEstimatedDate(htDealInfo),
    },
    hideDeliveryBannerInfo,
    verticalType,
    isNotGuaranteeDeal,
    isPurchaseAvailable,
    isEventDeliveryFree,
    isCvsPickupSupported,
    deliveryFee,
    deliveryFeePolicy,
    isExtraChargePrepayment,
    hasLongDistanceDelivery,
    longDistanceExtraDeliveryFee,
    extraChargeJeju,
    extraChargeExternalJeju,
    extraChargeDiscriminationMin,
    extraChargeDiscriminationMax,
    deliveryCorp,
    hasDifferentDeliveryFeePerLocal,
    dutyDeliveryRefund,
    soldOutReward,
    deliveryFeeContentPerLocal,
    refundType,
    deliveryType,
    deliveryProductType,
    deliverySpotType,
    minTotalPaidForFreeDelivery,
  };
}

/**
 * isValidGoCombinedDeliveryButton
 * 묶음상품 더보기(전체보기) 버튼 사용 가능한 앱 환경인지 검증하여 리턴한다.
 */
export function isValidGoCombinedDeliveryButton() {
  /* eslint-disable no-underscore-dangle */
  if (TMON.view_mode === "app" && !TMON.app._isValidAppVersion("4.5.8")) {
    return false;
  }
  return true;
}
